class NCProductCarousel extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.track = this.querySelector('[data-ncpcr-track]');
    this.prev = this.querySelector('[data-ncpcr-prev]');
    this.next = this.querySelector('[data-ncpcr-next]');
    if (!this.track) return;
    this.ticking = false;

    const step = (dir) => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
    };
    if (this.prev) this.prev.addEventListener('click', () => step(-1));
    if (this.next) this.next.addEventListener('click', () => step(1));

    const update = () => {
      this.ticking = false;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = max > 4;
      [this.prev, this.next].forEach((btn) => {
        if (btn) btn.hidden = !scrollable;
      });
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
    };
    const schedule = () => {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(update);
    };

    this.track.addEventListener('scroll', schedule, { passive: true });
    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(schedule);
      this.observer.observe(this.track);
    } else {
      window.addEventListener('resize', schedule, { passive: true });
    }
    update();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    this.ready = false;
  }
}

if (!customElements.get('nc-product-carousel')) {
  customElements.define('nc-product-carousel', NCProductCarousel);
}
